import { DatePicker, Divider } from 'antd'
import styles from '../../styles.module.scss'
import { useContext, useEffect, useState } from 'react'
import { UserInterface } from 'Interfaces'
import BaseLayout from 'components/BaseLayout'
import Context from 'containers/UMS/Users/Context'
import src from 'media/logo.png'
// helper
import { startOfYear, isBefore, endOfDay, subDays } from 'date-fns'
import get from 'lodash/get'
import find from 'lodash/find'
import useGetTransaction from './useGetTransaction'
import dayjs from 'dayjs'
import UserTransactionsList from './TransactionList'
import useLogAction from 'hooks/useLogAction'

const { RangePicker } = DatePicker

const UserTransactions: React.FC = () => {
  const {
    states: { selectedUser },
    queryHandler: { data: dataQuery }
  } = useContext(Context)
  const [value, setValue] = useState<any>([
    dayjs(subDays(new Date(), 6)),
    dayjs(new Date())
  ])
  const { mutate, isError, isLoading, records } = useGetTransaction()
  const { logAction } = useLogAction()

  const data = get(dataQuery, 'data', [])
  const user: UserInterface =
    find(data, ({ identity_uuid }) => selectedUser === identity_uuid) ?? {}

  useEffect(() => {
    logAction({
      action: "VIEW", event: "AIRFIND_USER", metadata: {
        actionType: "viewAirfindUserTransaction",
        userInfo: {
          uuid: selectedUser,
          firstname: user?.identity_first_name,
          lastname: user?.identity_last_name,
          email: user?.identity_email,
          phone: user?.identity_phone

        }
      }
    })
  }, [])

  useEffect(() => {
    mutate({
      user: selectedUser,
      startDate: value[0].toDate(),
      endDate: value[1].toDate()
    })
  }, [value])

  return (
    <div>
      <BaseLayout className="userTransactions">
        <img alt="P" src={src} />
        <div className="flexColumn">
          <div
            className="flexRow"
            style={{
              justifyContent: 'space-between',
              alignItems: 'center',
              margin: '15px 0'
            }}
          >
            <div>
              <span style={{ color: '#555', fontWeight: 900 }}>Usuario: </span>
              {`${user.identity_first_name} ${user.identity_last_name}`}
            </div>
            <RangePicker
              allowClear={false}
              value={value}
              onChange={setValue}
              disabledDate={currentDate =>
                !isBefore(currentDate.toDate(), endOfDay(new Date()))
              }
            />
          </div>
          <Divider style={{ margin: 0 }} />
          <div
            className="centerItem"
            style={{ marginTop: '15px', marginBottom: '-9px' }}
          >
            <div className={styles.updateUser}>
              <span style={{ color: '#555', fontWeight: 900 }}>
                Puntos Disponibles:
              </span>
              <pre style={{ margin: 0 }}>{` ${user.identity_point_count}`}</pre>
            </div>
          </div>
        </div>
      </BaseLayout>
      <BaseLayout
        className="transactionHistory"
        title="Historial de transacciones"
      >
        <UserTransactionsList
          records={records ? records : []}
          isLoading={isLoading}
          dates={value}
        />
      </BaseLayout>
    </div>
  )
}

export default UserTransactions
